export function ensureHttpsUrl(baseUrl: string): URL {
  const url = new URL(baseUrl, window.location.origin);
  const isLocalhost = /^(localhost|127\.0\.0\.1|\[[0-9a-f:]+\])$/i.test(url.hostname);
  if (!isLocalhost && url.protocol !== "https:") {
    throw new Error("Insecure scheme: use https for production environments");
  }
  return url;
}

export function clampMessageLength(msg: string, max = 4000): string {
  if (!msg || typeof msg !== "string") {
    throw new Error("Message must be a non-empty string");
  }
  if (msg.length > max) {
    throw new Error(`Message too long (max ${max} characters)`);
  }
  return msg;
}
